// extracted by mini-css-extract-plugin
module.exports = {"content":"SitewideBanner_content__ws1XT"};